module.exports = __webpack_public_path__ + "media/images/riders/small/RUDY_CABIROU-29ccf35b821ceea19f1590649de22efb.png";